import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

const vueConfig = require('vue-config')
import configs from './config.js';

import lodash from 'lodash'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash, lodash)

import Notifications from 'vue-notification'  
Vue.use(Notifications)

export const SocketInstance = socketio( configs.apiWs, { 
  autoConnect: false,
  //onconnect: function(){ 'socket connected' },
  //ondisconnect: function(){ 'socket disconnected' }
});

//SocketInstance.on('connect', function(){ 'socket connected' })



Vue.use(new VueSocketIO({
    debug: true,
    connection: SocketInstance,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}));
//Vue.use( VueSocketIO, SocketInstance, SocketInstance ); //, SocketInstance
Vue.use( vueConfig, configs);

router.afterEach((to, from) => {
/*
  console.log( 'from' );
  console.log( from );
  console.log( 'to' );
  console.log( to );
*/
  if( to.path != "/login") store.state.currentRoute = to.path;
//   console.log( store.state.currentRoute );
})

/*
router.beforEach((to, from, next) => {

})  
*/



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')





